import Img1 from "../school_images/career.png";
import Img2 from "../school_images/careery.jpg";
import Img3 from "../school_images/connectivity_image_for_School.jpg";
import Img4 from "../school_images/dropdown_logo.png";
import Img5 from "../school_images/event1.jpg";
import Img6 from "../school_images/event3.jpg";
import Img7 from "../school_images/event_1_.jpg";
import Img8 from "../school_images/event_4.jpg";
import Img9 from "../school_images/foote_bg.jpeg";
import Img10 from "../school_images/gdgoenkalogo.png";
import Img11 from "../school_images/hostel.jpeg";
import Img12 from "../school_images/tenet_2.jpg";
import Img13 from "../school_images/slide-1.png";
import Img14 from "../school_images/slide-0.png";
import Img15 from "../school_images/slide-2.png";
import Img16 from "../school_images/slide-4.jpg";
import Img17 from "../school_images/slide-6.jpg";
import Img18 from "../school_images/tenet3_image.jpg";
import Img19 from "../school_images/slide-3.jpg";
import Img20 from "../school_images/tenet_2.jpg";

export const ImageData = [
  { id: 1, ImageUrl: Img1 },
  { id: 2, ImageUrl: Img2 },
  { id: 3, ImageUrl: Img3 },
  { id: 4, ImageUrl: Img4 },
  { id: 5, ImageUrl: Img5 },
  { id: 6, ImageUrl: Img6 },
  { id: 7, ImageUrl: Img7 },
  { id: 8, ImageUrl: Img8 },
  { id: 9, ImageUrl: Img9 },
  { id: 10, ImageUrl: Img10 },
  { id: 11, ImageUrl: Img11 },
  { id: 12, ImageUrl: Img12 },
  { id: 13, ImageUrl: Img13 },
  { id: 14, ImageUrl: Img14 },
  { id: 15, ImageUrl: Img15 },
  { id: 16, ImageUrl: Img16 },
  { id: 17, ImageUrl: Img17 },
  { id: 18, ImageUrl: Img18 },
  { id: 19, ImageUrl: Img19 },
  { id: 20, ImageUrl: Img20 }
];
